import { memo, useCallback } from 'react'
import { Link, Stack, Typography } from '@mui/material'
import { showErrorSnackbar, showInfoSnackbar } from '@/utils/snackbars'

type RecoverPasswordRequestedProps = {
  email: string
  requestResetEmail: (email: string) => Promise<unknown>
}

function RecoverPasswordRequested({
  email,
  requestResetEmail,
}: RecoverPasswordRequestedProps) {
  const handleOnClick = useCallback(async () => {
    try {
      await requestResetEmail(email)
      showInfoSnackbar(
        'A new email has been sent to your inbox. Please check your email.',
      )
    } catch (e) {
      showErrorSnackbar(
        'An error occurred during the request. Please try again.',
      )
    }
  }, [email, requestResetEmail])

  return (
    <Stack spacing={2}>
      <Typography>Check Your Email!</Typography>
      <Typography>
        An email was sent to{' '}
        <Typography color="primary" component="span">
          {email}
        </Typography>{' '}
        to reset your password.
      </Typography>
      <Typography>
        Didn&apos;t get it?{' '}
        <Link
          onClick={handleOnClick}
          underline="hover"
          sx={{ cursor: 'pointer' }}
        >
          Resend email
        </Link>
      </Typography>
    </Stack>
  )
}

export default memo(RecoverPasswordRequested)
